import { useEffect, useState } from "react";
import api from "../../../lib/api";
import { Save, Check, Eye, EyeOff, Lock } from "lucide-react";

const PAGES = [
  { key: "home", label: "Accueil", desc: "Page d'accueil — toujours visible", locked: true },
  { key: "services", label: "Services", desc: "Page détaillée des prestations" },
  { key: "pricing", label: "Tarifs", desc: "Page tarifs avec packs" },
  { key: "gallery", label: "Galerie", desc: "Galerie photos par catégorie" },
  { key: "blog", label: "Blog", desc: "Articles et actualités" },
  { key: "about", label: "À propos", desc: "Présentation de la photographe" },
  { key: "contact", label: "Contact", desc: "Formulaire de contact" },
];

export default function PagesVisibilityManager() {
  const [vis, setVis] = useState({});
  const [loading, setLoading] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    api.get("/content/pages_visibility").then(({ data }) => setVis(data || {})).catch(() => setVis({}));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggle = (key) => {
    if (key === "home") return;
    setVis({ ...vis, [key]: vis[key] === false ? true : false });
  };

  const save = async () => {
    setLoading(true);
    try {
      const payload = { ...vis, home: true };
      await api.put("/content/pages_visibility", { data: payload });
      setSaved(true);
      setTimeout(() => setSaved(false), 2200);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="pages-visibility-manager">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="font-serif text-4xl">Pages publiques</h1>
          <p className="text-[#4A3F35] mt-2">Cachez certaines pages du menu principal sans les supprimer (les URLs restent accessibles).</p>
        </div>
        <button onClick={save} disabled={loading} className="btn-primary disabled:opacity-50" data-testid="pages-visibility-save">
          {saved ? <><Check size={16} /> Enregistré</> : <><Save size={16} /> Enregistrer</>}
        </button>
      </div>

      <div className="bg-[#FDFBF7] rounded-2xl border border-[#2D2A26]/10 divide-y divide-[#2D2A26]/10">
        {PAGES.map((p) => {
          const active = vis[p.key] !== false;
          const iconCls = p.locked
            ? "bg-[#C87A5E]/15 text-[#C87A5E]"
            : active
              ? "bg-[#8A9A86]/15 text-[#8A9A86]"
              : "bg-[#2D2A26]/5 text-[#2D2A26]/40";
          let icon;
          if (p.locked) icon = <Lock size={16} />;
          else if (active) icon = <Eye size={18} />;
          else icon = <EyeOff size={18} />;
          let switchCls;
          if (p.locked) switchCls = "bg-[#C87A5E]/30 cursor-not-allowed";
          else if (active) switchCls = "bg-[#8A9A86]";
          else switchCls = "bg-[#2D2A26]/15";
          return (
            <div key={p.key} className="flex items-center justify-between p-5">
              <div className="flex items-start gap-4">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center ${iconCls}`}>{icon}</div>
                <div>
                  <h3 className="font-serif text-xl">{p.label}</h3>
                  <p className="text-sm text-[#4A3F35]/70">{p.desc}</p>
                </div>
              </div>
              <button
                onClick={() => toggle(p.key)}
                disabled={p.locked}
                className={`relative w-14 h-8 rounded-full transition ${switchCls}`}
                data-testid={`page-toggle-${p.key}`}
              >
                <span className={`absolute top-1 left-1 w-6 h-6 rounded-full bg-white shadow transition ${active ? "translate-x-6" : ""}`} />
              </button>
            </div>
          );
        })}
      </div>

      <p className="mt-6 text-sm text-[#4A3F35]/60">💡 Une page cachée disparaît du menu et du footer, mais son URL reste fonctionnelle (utile pour partager un lien direct).</p>
    </div>
  );
}
